<script>
import { angularInvoke } from "/vodalys/vvuejs";
import { asyncAngularInvoke } from "/vodalys/vvuejs";

export default {
  translate25Context: "vprojector",
  mounted: function () {
    this.vnotification_service_js = angularInvoke(
      (vnotification_service_js) => vnotification_service_js
    );
  },
  props: ["component", "handler"],
  data: () => {
    return {
      pending: false,
      promiseResolve: null,
      promiseReject: null,
    };
  },
  watch: {
    "component.last_created_url": function (url) {
      if (url) {
        window.location.hash = url;

        this.pending = false;

        if (this.promiseResolve) this.promiseResolve();
      }
    },
    "component.task_state": function (task_state) {
      if (task_state == "error" && this.component.task_last_error) {
        this.vnotification_service_js.add({
          "#type": "vnotification:js",
          label: this.component.task_last_error,
          delay: 15000,
          severity: 2,
        });

        this.pending = false;

        if (this.promiseReject) this.promiseReject();
      }
    },
  },
  methods: {
    async start() {
      let zis = this;

      var promiseResolve, promiseReject;

      angularInvoke(function (
        v17Modal,
        $rootScope,
        $rootElement,
        vTranslateService
      ) {
        v17Modal.inputAndDate($rootScope, $rootElement.find("body"), {
          classes: "projector-item-modal",
          title: zis.$vt(
            "Set a title and a date for your new project"
          ),
          date: new Date(),
          placeholder: zis.component.data.title,
          ok: function (title, date) {
            zis.pending = true;

            return new Promise((resolve, reject) => {
              zis.handler
                .action(zis.component["#id"], "create", [title, date])
                .then(
                  function () {
                    zis.promiseResolve = resolve;
                    zis.promiseReject = reject;
                  },
                  function () {
                    reject();
                    zis.pending = false;
                  }
                );
            });
          },
          okLabel: zis.$vt("Start"),
          yesType: "highlight",
        });
      });
    },
  },
};
</script>

<template>
  <div
    class="vprojector-card item"
    :class="{ pending: pending, disabled: !component['#actions']['create'] }"
    @click="start()"
  >
    <div class="icon">
      <f-icon :icon="component.data.icon" figma></f-icon>
    </div>
    <div class="title">{{ $vt(component.data.title) }}</div>
    <div
      class="tag"
      :class="{ highlight: component.data.tag_highlight }"
      v-if="component.data.tag"
    >
      {{ $vt(component.data.tag) }}
    </div>
    <div class="list">
      <div
        class="list-item"
        v-for="(list_item, index) in component.data.list"
        :key="index"
      >
        <div class="list-item-icon"><f-icon icon="fa6-check"></f-icon></div>
        <div>{{ $vt(list_item.text) }}</div>
      </div>
    </div>
    <div class="cost">{{ $vt(component.data.cost) }}</div>
    <div class="viewers">{{ $vt(component.data.viewers) }}</div>
    <f-button
      v-if="component['#actions']['create']"
      :pending="pending"
      class="view"
      type="highlight"
      >{{$vt('Start')}} <f-icon icon="fa6-arrow-right"></f-icon
    ></f-button>
    <div v-if="!component['#actions']['create']" class="permissionlabel">
      {{$vt(component.permission_label) }}
    </div>
  </div>
</template>

<style lang="scss">
.projector-item-modal
{
  .f-dialog
  {
    width: 390px;
  }
}

.vprojector-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px 32px;
  width: 240px;
  height: 100%;
  min-height: 450px;
  background: var(--black);
  box-shadow: 0px 24px 32px -8px rgba(22, 21, 21, 0.5);
  border-radius: 12px;
  cursor: pointer;

  .icon {
    width: 96px;
    height: 96px;
  }

  .title {
    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 100%;
	padding: 8px;
    text-align: center;
    color: var(--white-a75);
  }

  .cost {
    margin-top: 16px;
    font-weight: bold;
    font-size: 12px;
    line-height: 125%;
    padding-top: 5px;
  }

  .tag {
    margin-top: 8px;
    background: transparent;
    border-radius: 16px;
    padding: 4px 12px;
    text-align: center;
    font-family: Lato;
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 125%;
    color: var(--white-a75);

    &.highlight {
      background: var(--primary);
      color: var(--black);
    }
  }

  .list {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    .list-item {
      display: flex;
      font-family: Lato;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 125%;
      color: var(--white-a75);

      .list-item-icon {
        margin-right: 10px;
		margin-top:2px;
        color: #5cbab6;
      }
    }
  }
  .cost {
    margin-top: auto;
    padding-top: 16px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 125%;
    color: var(--white-a75);
  }

  .viewers {
    margin-top: 2px;
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 125%;
    color: var(--white-a75);
  }

  &.disabled {
    cursor: default;
    opacity: 1;
    pointer-events: none;
  }

  .permissionlabel {
    margin-top: 17px;
    text-align: center;
    color: var(--primary);
  }

  .f-button {
    margin-top: 16px;
  }
}
</style>
